<template>
  <div class="collection-bill-detail">
    <div class="header">
      <div class="title">收款单详情</div>
      <div class="search">
        <el-form inline class="inline-form" :model="searchForm" label-width="85px" label-position="right">
          <el-form-item label="订单创建时间" label-width="100px">
            <el-date-picker
              v-model="searchForm.rangeTime"
              size="small"
              clearable
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item label="收款订单号" label-width="100px">
            <el-input v-model="searchForm.payOrderNo" size="small" clearable placeholder="请输入收款订单号"/>
          </el-form-item>
          <el-form-item label="乐刷商户号" label-width="100px">
            <el-input v-model="searchForm.merchantId" size="small" clearable placeholder="请输入乐刷商户号"/>
          </el-form-item>
          <el-form-item label="交易状态" label-width="100px">
            <el-select v-model="searchForm.status" size="small" clearable placeholder="请选择交易状态">
              <el-option
                v-for="(item, index) in searchForm.statusOptions"
                :key="index"
                :value="item.value"
                :label="item.label"/>
            </el-select>
          </el-form-item>
          <el-form-item label="支付方式" label-width="100px">
            <el-select v-model="searchForm.payType" size="small" clearable placeholder="请选择付款方式">
              <el-option
                v-for="item in payTypeOptions"
                :key="item.label"
                :value="item.value"
                :label="item.label"/>
            </el-select>
          </el-form-item>
          <el-form-item label="交易类型">
            <el-select v-model="searchForm.orderType" size="small" clearable filterable placeholder="请选择交易类型">
              <el-option label="全部" value=""/>
              <el-option v-for="(item, key, index) in mapTransType" :key="index" :value="Number(key)" :label="item"/>
            </el-select>
          </el-form-item>
          <el-button type="primary" size="small" @click="handleSearch" class="btn-base searchBtn bs-btn">查询</el-button>
          <el-button size="small" @click="exportDetail" class="btn-base searchBtn bs-btn">导出明细</el-button>
        </el-form>
      </div>
    </div>
    <div class="center-info">
      <span v-for="(item, index) in Object.entries(billInfo)" :key="index">
        {{ billInfoToChinese(item[0]) }}: {{ item[1] }}
      </span>
    </div>
    <div class="table-list">
      <div class="table-data">
        <el-table :data="table.tableData" style="width: 100%;" border v-loading="table.loadingTable">
          <el-table-column prop="createTime" label="订单创建时间" align="center" width="200"/>
          <el-table-column prop="payOrderNo" label="收款订单号" align="center" width="150"/>
          <el-table-column prop="lsOrderNo" label="交易订单号" align="center" width="150"/>
          <el-table-column prop="tradeAmount" label="交易金额" align="center" width="120">
            <template slot-scope="{ row }">{{ sToFixed(row.tradeAmount / 100) }}</template>
          </el-table-column>
          <el-table-column prop="orderType" label="交易类型" align="center" width="120">
            <template slot-scope="{ row }">{{ mapTransType[row.orderType] }}</template>
          </el-table-column>
          <el-table-column prop="status" label="交易状态" align="center" width="100">
            <template slot-scope="{ row }">{{ getValue(row.status, searchForm.statusOptions) }}</template>
          </el-table-column>
          <el-table-column prop="payTime" label="交易时间" align="center" width="200"/>
          <el-table-column prop="payType" label="支付方式" align="center" width="100">
            <template slot-scope="{ row }">{{ getValue(row.payType, searchForm.payTypeOptions) }}</template>
          </el-table-column>
          <el-table-column prop="receiptOrderNo" label="收款单编号" align="center" width="150"/>
          <el-table-column prop="receiptName" label="收款单名称" align="center" width="150"/>
          <el-table-column prop="tradeAmountStr" label="顾客信息" align="center" width="120">
            <template slot-scope="{$index, row}">
              <span v-if="!row.customerInfo || !row.customerInfo.length">-</span>
              <el-tooltip
                v-else
                placement="bottom"
                title="标题"
                width="200"
                trigger="hover"
              >
                <div v-html="customerInfoTxt(row.customerInfo, 2)" style="text-align: left;"></div>
                <div slot="content" v-html="customerInfoTxt(row.customerInfo)"></div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="merchantId" label="乐刷商户号" align="center" width="150"/>
          <el-table-column prop="shopId" label="门店编号" align="center" width="150"/>
          <el-table-column prop="merchantName" label="门店名称" align="center" min-width="200"/>
          <el-table-column prop="cashierAreaName" label="关联收银点" align="center" min-width="200"/>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="table.totalCount > 0"
            class="pagination"
            :page-size="table.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="table.totalCount"
            :current-page="table.pageNo"
            @current-change="handleCurrentPageChange"
          />
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
import { getReceiptDetailList, queryRecordSummary } from '@/api/collection-bill';
import { downLoadFileByForm, sToFixed } from "@/utils/index";
import { host } from "@/global-config";

export default {
  name: "collection-bill-detail",
  data() {
    return {
      // 枚举
      mapTransType: { // 交易类型
        1: '收款',
        2: '退款',
      },
      searchForm: {
        rangeTime: null,
        payOrderNo: '',
        merchantId: '',
        payType: '',
        status: '',
        orderType: '',
        statusOptions: [
          { value: -1, label: '已取消' },
          { value: 0, label: '待支付' },
          { value: 1, label: '支付成功' },
          { value: 2, label: '支付失败' },
          { value: 3, label: '已退款' },
          { value: 4, label: '退款中' },
          { value: 5, label: '退款失败' },
        ],
        payTypeOptions: [
          { value: 0, label: '' },
          { value: 1, label: '微信' },
          { value: 2, label: '支付宝' },
        ],
      },
      payTypeOptions: [{ value: '', label: '全部' }, { value: 1, label: '微信' }, { value: 2, label: '支付宝' }],
      billInfo: {
        totalAmount: 0,
        incomeAmount: 0,
        incomeCount: 0,
        refundAmount: 0,
        refundCount: 0,
      },
      table: {
        tableData: [],
        loadingTable: false,
        totalCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    loginInfo() {
      return JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
    },
    receiptOrderNo() {
      return this.$route.query.receiptOrderNo;
    },
    getValue() {
      return (val, options) => {
        const item = options.find(i => i.value === val);
        return item ? item.label : '';
      };
    },
    billInfoToChinese() {
      const obj = {
        totalAmount: '累计营业收入(元)',
        incomeAmount: '累计收款金额(元)',
        incomeCount: '累计收款笔数(笔)',
        refundAmount: '累计退款金额(元)',
        refundCount: '累计退款笔数(笔)',
      };
      return val => obj[val];
    },
    searchParamsCombine() {
      const {
        rangeTime,
        payOrderNo,
        merchantId,
        status,
        payType,
        orderType,
      } = this.searchForm;
      return {
        startTime: rangeTime ? rangeTime[0] : '',
        endTime: rangeTime ? rangeTime[1] : '',
        payOrderNo,
        merchantId,
        status,
        receiptOrderNo: this.receiptOrderNo,
        payType,
        orderType,
      };
    },
    customerInfoTxt() {
      return (list, lineNum) => {
        if (!list.length) return '-';
        return lineNum ? list.slice(0, lineNum).join('<br>') : list.join('<br>');
      };
    },
  },
  mounted() {
    this.queryTableData();
    this.queryBillInfo();
  },
  methods: {
    sToFixed,
    async queryBillInfo() {
      const { data: { data } } = await queryRecordSummary({ ...this.searchParamsCombine });
      const billInfoObj = {
        totalAmount: sToFixed(data.totalAmount),
        incomeAmount: sToFixed(data.incomeAmount),
        incomeCount: data.incomeCount,
        refundAmount: sToFixed(data.refundAmount),
        refundCount: data.refundCount,
      };
      Object.assign(this.billInfo, billInfoObj);
    },
    async queryTableData() {
      this.table.loadingTable = true;
      const { pageNo, pageSize } = this.table;
      const params = {
        ...this.searchParamsCombine,
        pageNo,
        pageSize,
      };
      const { data: { data: { list = [], totalCount = 0 } } } = await getReceiptDetailList({ ...params }).finally(() => {
        this.table.loadingTable = false;
      });
      this.table.tableData = list;
      this.table.totalCount = totalCount;
      this.table.tableData.forEach((v) => {
        const { customerInfo } = v;
        v.customerInfo = customerInfo.map((c) => {
          const title = c.title;
          const value = c.remarkOptionsList.map(r => r.content).join(',');
          return `${title}：${value}`;
        });
      });
    },
    handleSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
      this.queryBillInfo();
    },
    exportDetail() {
      const { userName, sessionId } = this.loginInfo;
      const url = `${host}/receipt-order-trans/exportByReceiptOrderNo?userName=${userName}&sessionId=${sessionId}`;
      downLoadFileByForm(url, { ...this.searchParamsCombine });
    },
    handleCurrentPageChange(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
  },
};
</script>

<style scoped lang="scss">
.collection-bill-detail {
  background-color: #f7f7f7;

  .header {
    padding-left: 50px;
    margin-bottom: 20px;
    background-color: #fff;

    .btn-base {
      height: 32px;
      margin-top: 5px;
      line-height: 0;
    }

    .search {
      padding-bottom: 20px;
      margin-top: 40px;
    }

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .center-info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 20px 0;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .table-list {
    overflow: hidden;
    background: #f7f7f7;

    .table-data {
      padding: 40px 50px;
      overflow: hidden;
      background-color: #fff;

      .table-btn {
        margin-right: 10px;
        color: #ff9c00;
        cursor: pointer;
      }
    }
  }
}
</style>
